import React from 'react';

function YellowBox() {
  const boxStyle = {
    backgroundColor: 'yellow',
    width: '100px',
    height: '50px',
  };

  return (
    <div style={boxStyle}></div>
  );
}

export default YellowBox;